import { Typography, Space, Row, Col, Button, Divider, Card, message } from "antd";
import { CheckOutlined } from '@ant-design/icons';
import { cacheBuster } from "../../../utils/Utils";
import { apiCall } from "../../../utils/Api";
import { useState, useEffect } from "react";


export default function MessagePreview(props) {

    const { value , ws, confirm = false, details } = props;

    const [ogPath, setOgPath] = useState("");

    const getOgPath = (_p) => {
        setOgPath("https://bookmanager.com/" + _p + "?cb=" + cacheBuster());
    }

    const wsReplaced = typeof ws === "string" ? ws.replace(/@@phone@@/g, details["ms0:ws_footer_data"].phone ? details["ms0:ws_footer_data"].phone : "@@phone@@").replace(/@@email@@/g, details["ms0:order_email"] ? details["ms0:order_email"] : "@@email@@") : ws;

    
    const getSettings = () => {
        apiCall("printer_logo/getSettings", {}, (_status, _result) => {
            if (_status) {
                getOgPath(_result.logo_path); 
            } else {
                message.error(_result.error);
            }
        })
    }

    const storeIcon = (
        <div style={{ height: "150px", display: "flex", alignItems: "center", justifyContent: "left" }}>
            <img
                src={ogPath}
                alt="store logo"
                style={{
                    maxHeight: "100%",
                    width: "auto",
                    objectFit: "contain",
                    marginBottom: "20px"
                }}
            />
        </div>
    )

    useEffect(getSettings, []);

    const confirmMessage = (
        <>
            Thank you! Your order has been submitted.<br /><br />
            <strong><i>When can you pick up your order?</i></strong><br /><br />
            You'll receive an email when your order is ready for in-store pick up. Pick up is available during business hours. For immediate assistance, please call during regular business hours.
            <br/>
            <br/>
        </>
    );

    switch (value) {
        case "ws_message_checkout":
            return (
                <div style={{ padding: "20px" }}>
                    <Typography.Title level={5}>Checkout message for all orders</Typography.Title>
                    <div
                        style={{ padding: "30px", border: "1px dashed #ddd" }}
                        dangerouslySetInnerHTML={{ __html: wsReplaced }}
                    />
                </div>
            );
            break
        case "ws_message_ship_cart":
            return (
                <div style={{ padding: "20px" }}>
                    <Typography.Title level={5}>Custom checkout message for Shipping Orders</Typography.Title>
                    <Card className="preview-shipping" style={{ "border": "1px solid #6cba66", "cursor": "pointer", "transition": "0.5s", "backgroundColor": "#f7fff6" }}>
                        <Row style={{ "color": "#000"}} align="middle" gutter={30}>
                            <Col xs={12} sm={5}>
                                <Space className="bw" size={15}>
                                    <CheckOutlined aria-hidden style={{ "fontSize": "20px" }} />
                                    <span style={{ "fontWeight": "bold"}}>Canada post</span>
                                </Space>
                            </Col>

                            <Col className="hide-block bw" xs={24} sm={16}>
                                No delivery <strong>ETA</strong> available at this time
                            </Col>
                            <Col style={{ "borderLeft": "1px solid #eee" }} xs={12} sm={3}>
                                <div style={{ "textAlign": "center" }}><Button><strong><em>TBD</em></strong></Button></div>
                            </Col>

                            <Col xs={24} sm={16} className="bw">
                                <div aria-hidden><Divider dashed style={{ "margin": "15px 0px" }} /></div>
                                <div dangerouslySetInnerHTML={{ __html: wsReplaced }}/>
                            </Col>
                        </Row>
                    </Card>
                </div>
            )
            break;  
        case "ws_message_pickup":
            const pickupMsg = (wsReplaced).replace(/\n/g, "<br />");
            return (
                <div style={{ padding: "20px" }}>
                    <Typography.Title level={5}>Custom confirmation email message for Pick Up orders</Typography.Title>
                    <div style={{ padding: "30px 110px" }}>
                        {ogPath && storeIcon}
                        {confirm && <div>{confirmMessage}</div>}
                        <div dangerouslySetInnerHTML={{ __html: pickupMsg }} />
                    </div> 
                </div>
            )
            break;
        case "ws_message_ship":
            const shipMsg = (wsReplaced).replace(/\n/g, "<br />");
            return (
                <div style={{ padding: "20px" }}>
                    <Typography.Title level={5}>Custom confirmation email message for Shipping orders</Typography.Title>
                    <div style={{ padding: "30px 110px" }}>
                        {ogPath && storeIcon}
                        {confirm && <div>{confirmMessage}</div>}
                        <div dangerouslySetInnerHTML={{ __html: shipMsg }} />
                    </div> 
                </div>
            )
            break;
        case "ws_message_local_cart":
            const localCartMsg = (wsReplaced).replace(/\n/g, "<br />");
            return (
                <div style={{ padding: "20px" }}>
                    <Typography.Title level={5}>Custom checkout and confirmation email message for Local Delivery orders</Typography.Title>
                    <div style={{ padding: "30px 110px" }}>
                        {ogPath && storeIcon}
                        {confirm && <div>{confirmMessage}</div>}
                        <div dangerouslySetInnerHTML={{ __html: localCartMsg }} />
                    </div>
                </div>
            )
        default:
            return (
                <div style={{ padding: "20px" }}>
                    No preview available.
                </div>
            )
    }

}